<template>
  <b-button v-if="showAsButton"
            :variant="isRemove ? 'secondary' : 'primary'"
            :disabled="disabled || loading"
            class="btn-toggle-cart"
            size="sm"
            @click="$emit('click')">
    <b-spinner small v-if="loading"/>
    <template v-else>
      <span class="btn-toggle-cart__sign">{{ isRemove ? '−' : '+' }}</span>
      {{ isRemove ? $t('collage_photo_item.remove_from_cart') : $t('collage_photo_item.add_to_cart') }}
    </template>
  </b-button>
  <a v-else href="#" class="nav-link" @click.prevent="$emit('click')">
    <icon-cart :width="width" :height="height" :rx="rx" :action="action" :loading="loading"></icon-cart>
  </a>
</template>

<script>
import IconCart from "@/components/interface/svg/IconCart.vue";
import {cartActions} from "@/domain/galleries/constants";

export default {
  name: "ButtonToggleCart",
  components: {IconCart},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    },
     width: {
      required: false,
      type: Number
    },
    height: {
      required: false,
      type: Number
    },
    rx: {
      required: false,
      type: Number
    },
    showAsButton: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isRemove() {
      return this.action === cartActions.REMOVE
    }
  }
}
</script>
